import {
    FETCH_SEGMENT_LIST,
    FETCH_SEGMENT_LIST_DATA,
    FETCH_SEGMENT_LIST_ERROR,

    // Create New Segment
    CREATE_NEW_SEGMENT,
    CREATE_NEW_SEGMENT_SUCCESS,
    CREATE_NEW_SEGMENT_ERROR,

    // Edit Segment
    EDIT_SEGMENT,
    EDIT_SEGMENT_SUCCESS,
    EDIT_SEGMENT_ERROR,
} from './constants';

// FETCH SEGMENTS
export const fetchSegments = () => ({
    type: FETCH_SEGMENT_LIST,
});

export const fetchSegmentsSuccess = (payload) => ({
    type: FETCH_SEGMENT_LIST_DATA,
    payload,
});

export const fetchSegmentError = () => ({
    type: FETCH_SEGMENT_LIST_ERROR,
});

// CREATE NEW SEGMENT
export const createNewSegment = (payload, message) => ({
    type: CREATE_NEW_SEGMENT,
    payload,
    message,
});

export const createNewSegmentSuccess = (payload) => ({
    type: CREATE_NEW_SEGMENT_SUCCESS,
    payload,
});

export const onCrateNewSegmentError = () => ({
    type: CREATE_NEW_SEGMENT_ERROR,
});

// EDIT SEGMENT
export const editSegment = (originalSegment, newData, message) => ({
    type: EDIT_SEGMENT,
    payload: { originalSegment, newData },
    message,
});

export const editSegmentSuccess = (payload) => ({
    type: EDIT_SEGMENT_SUCCESS,
    payload,
});

export const editSegmentError = () => ({
    type: EDIT_SEGMENT_ERROR,
});
